import { IFlightReportDashboard } from '../model/flightReportDashboard/IFlightReportDashboard';
import { IFlightReport } from '../model/IFlightReport';
import { FlightReportService } from './flightReport/FlightReportService';

export const downloadPdf = async (user: string, flightReportId: number, contractRegistrationName: string) => {
  try {
    const response = await FlightReportService.getPdf(flightReportId, user);
    const url = window.URL.createObjectURL(response.data);
    const contentDisposition = response.headers['Content-Disposition'];
    let fileName = `${contractRegistrationName}_FlightReport${flightReportId}.pdf`; // Default filename
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="(.+?)"/);
      if (match) fileName = match[1];
    }
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading PDF:', error);
  }
};
export function showPdf(record: IFlightReportDashboard | IFlightReport) {
  const status = record.status?.toLowerCase();
  return record.hasPdf && (status === 'signed off' || status === 'approved' || status === 'processed');
}
